import React from 'react'
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle
} from '@/components/ui/dialog'

export default function SimpleModal ({ contentRef, size, isOpen, onClose, header, body, footer, trigger, closeOnInteractOutside = true }) {
  return (
    <>
      {trigger}
      <DialogRoot
        placement='center'
        motionPreset='slide-in-bottom'
        lazyMount
        open={isOpen}
        onOpenChange={(e) => {
          if (typeof onClose !== 'function') return
          if (e?.open === false) onClose()
        }}
        size={size}
        // Clicking away closes, as Escape does. This was off because
        // `onOpenChange` used to call `onClose` for *any* open-change event, so
        // a nested interaction shut the dialog; it now only fires on close.
        // Pass `closeOnInteractOutside={false}` on a modal that must not be
        // dismissed by a stray click.
        closeOnInteractOutside={closeOnInteractOutside}
      >
        <DialogContent ref={contentRef}>
          <DialogHeader>
            <DialogTitle>{header}</DialogTitle>
            <DialogCloseTrigger />
          </DialogHeader>
          <DialogBody>
            {body}
          </DialogBody>
          {footer && (
            <DialogFooter>
              {footer}
            </DialogFooter>
          )}
        </DialogContent>
      </DialogRoot>
    </>
  )
}
